"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.en = exports.es = exports.az = void 0;
const az_js_1 = __importDefault(require("./locales/az.js"));
exports.az = az_js_1.default;
const en_js_1 = __importDefault(require("./locales/en.js"));
exports.en = en_js_1.default;
const es_js_1 = __importDefault(require("./locales/es.js"));
exports.es = es_js_1.default;
